import gql from 'graphql-tag'

export const GET_CHANNEX_REMOTE_OPTIONS_QUERY = gql`
  query GetChannexRemoteOptions {
    getChannexRemoteOptions {
      roomTypes {
        id
        title
      }
      ratePlans {
        id
        title
        roomTypeId
      }
    }
  }
`
